import React from 'react';

export function PageHero({ icon, title, subtitle, extra, children }) {
  return (
    <div className="page-hero">
      <div className="page-hero-main">
        {icon && <div className="page-hero-icon">{icon}</div>}
        <div>
          <div className="page-hero-title">{title}</div>
          {subtitle && <div className="page-hero-sub">{subtitle}</div>}
        </div>
      </div>
      {extra && <div className="page-hero-extra">{extra}</div>}
      {children}
    </div>
  );
}

export function StatTile({ icon, label, value, hint, tone = 'violet', onClick }) {
  return (
    <div className={`stat-tile tone-${tone}${onClick ? ' is-click' : ''}`} onClick={onClick} role={onClick ? 'button' : undefined}>
      <div className="stat-tile-icon">{icon}</div>
      <div className="stat-tile-body">
        <div className="stat-tile-label">{label}</div>
        <div className="stat-tile-value">{value}</div>
        {hint && <div className="stat-tile-hint">{hint}</div>}
      </div>
    </div>
  );
}
